import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-payment-method-added-dialog-content',
  templateUrl: './payment-method-added-dialog-content.component.html',
  styleUrls: ['./payment-method-added-dialog-content.component.css']
})
export class PaymentMethodAddedDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'PaymentMethodAddedDialogContentComponent';

  constructor(
    public activeModal: NgbActiveModal,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit() {
    super.ngOnInit
  }

  onConfirmClick() {
    this.activeModal.close();
  }
}
